const CHROMA_KEY_COLOR = "#7813ab";

export { CHROMA_KEY_COLOR };
